/**
 * Toggle between List and Tournament rating modes.
 */

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { List, Trophy } from 'lucide-react';

export type RatingMode = 'list' | 'tournament';

interface ModeToggleProps {
  mode: RatingMode;
  onModeChange: (mode: RatingMode) => void;
  disabled?: boolean;
}

export function ModeToggle({ mode, onModeChange, disabled }: ModeToggleProps) {
  return (
    <Tabs
      value={mode}
      onValueChange={(value) => onModeChange(value as RatingMode)}
    >
      <TabsList className="grid w-full grid-cols-2">
        <TabsTrigger
          value="list"
          disabled={disabled}
          className="flex items-center gap-1.5"
        >
          <List className="w-4 h-4" />
          <span className="hidden sm:inline">List</span>
        </TabsTrigger>
        <TabsTrigger
          value="tournament"
          disabled={disabled}
          className="flex items-center gap-1.5"
        >
          <Trophy className="w-4 h-4" />
          <span className="hidden sm:inline">Tournament</span>
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
